import { useRef, useState, useEffect } from "react";
import { PackageType } from "../../../interfaces/promotionCard/PromotionCard.type";
import styles from "./PromotionCardMobile.module.css";
import useComponentsStore from "../../../store/componentsStateStore";
import { logOrderProductsClickAddCart } from "../../../membership/logging/helpers/commonLoggingFunctions";
import { styleHelper } from "../../../helpers/commonFunctions";

export default function PromotionCardMobile({
  pkg,
  setIsDisabled,
  isDisabled,
}: {
  pkg: PackageType;
  setIsDisabled: any;
  isDisabled: boolean;
}) {
  const savePill = pkg.data?.savePill;
  const quantity = pkg.data?.quantity;
  const unitPrice = pkg.data?.unitPrice;
  const highlightLabel = pkg.data?.highlightLabel;
  const strikeThroughUnitPrice = pkg.data?.strikeThroughUnitPrice;
  const payload = pkg?.payload;
  const selectedData = pkg?.selectedData;
  const defaultData = pkg?.defaultData;
  const [isLoading, setIsLoading] = useState(false);
  const { continueDraft } = useComponentsStore();
  const checked = useRef(null),
    unchecked = useRef(null);

  useEffect(() => {
    if (!checked?.current && checked?.current?.src) {
      checked.current = new Image();
      checked.current.src =
        "https://opensooqui-new.s3.amazonaws.com/os_web/desktop/addPost/checked.png";
    }
    if (!unchecked?.current && unchecked?.current?.src) {
      unchecked.current = new Image();
      unchecked.current.src =
        "https://opensooqui-new.s3.amazonaws.com/os_web/desktop/addPost/unchecked.png";
    }
  }, []);

  const onClickHandler = async () => {
    if (isLoading || isDisabled) return;
    try {
      if (pkg && !pkg.isChecked) logOrderProductsClickAddCart();
      setIsLoading(true);
      setIsDisabled(true);
      await continueDraft(payload);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  const IconContent = () => {
    return (
      <>
        {isLoading && (
          <i
            className="vas-text-success vas-spinner-border "
            style={styleHelper({ width: "18px", height: "18px" })}
          />
        )}
        {!isLoading && pkg.isChecked && (
          <img
            className="vas"
            src={
              checked?.current?.src ||
              "https://opensooqui-new.s3.amazonaws.com/os_web/desktop/addPost/checked.png"
            }
            alt="checked_card"
            width={16}
            height={16}
          />
        )}
        {!isLoading && !pkg.isChecked && (
          <img
            className="vas"
            src={
              unchecked?.current?.src ||
              "https://opensooqui-new.s3.amazonaws.com/os_web/desktop/addPost/unchecked.png"
            }
            alt="unchecked_card"
            width={16}
            height={16}
          />
        )}
      </>
    );
  };

  return (
    <div className="vas-d-flex vas-flex-column vas-align-items-center vas-my-2">
      {savePill && savePill?.text ? (
        <div
          className={`vas-border vas-border-2 vas-border-radius vas-text-center vas-fw-bold vas-text-13 ${styles?.consumer_tag}`}
          style={styleHelper({
            backgroundColor: savePill?.backgroundColor,
            color: savePill?.textColor,
            borderColor: savePill?.borderColor,
          })}
        >
          {savePill.text}
        </div>
      ) : (
        <div className={`${styles.consumer_tag} vas-border-radius`}></div>
      )}
      <div
        onClick={onClickHandler}
        className={`vas-d-flex vas-flex-column vas-px-1 vas-py-2 vas-gap-1 vas-border-radius ${
          styles.card
        }  ${isDisabled ? "notAllowedPointer" : "pointerCursor"}`}
        style={styleHelper({
          backgroundColor: pkg?.isChecked
            ? selectedData?.backgroundColor
            : defaultData?.backgroundColor,
          border: `2px solid ${
            pkg?.isChecked
              ? selectedData?.borderColor
              : defaultData?.borderColor
          }`,
        })}
      >
        <div className="vas-d-flex vas-flex-column vas-align-items-center vas-justify-content-center">
          <span
            className={`vas-d-block vas-text-13 vas-mt-2 vas-mb-1 ${styles.header_holder}`}
            style={styleHelper({ color: highlightLabel?.textColor })}
          >
            {highlightLabel?.text ?? ""}
          </span>
          <span
            className="vas-d-block vas-text-26 vas-fw-bold"
            style={styleHelper({ color: quantity?.textColor })}
          >
            {quantity?.text ?? ""}
          </span>
          <span
            className="vas-text-14"
            style={styleHelper({ color: quantity?.subtitle?.textColor })}
          >
            {quantity?.subtitle?.text ?? ""}
          </span>
          <div
            className={`vas-text-12 ${styles.subtitle_description_holder}`}
            style={styleHelper({
              color: quantity?.subtitleDescription?.textColor,
            })}
          >
            {quantity?.subtitleDescription?.text}
          </div>
        </div>
        <div className="vas-d-flex vas-flex-column vas-align-items-center vas-justify-content-center vas-gap-1 vas-text-center">
          <div>
            <span
              className={`vas-d-block vas-text-danger vas-text-decoration-line-through vas-text-12 ${styles.previous_price_holder}`}
              style={styleHelper({ color: strikeThroughUnitPrice?.textColor })}
            >
              {strikeThroughUnitPrice?.text ?? ""}
            </span>
            <span
              className="vas-d-block vas-text-14"
              style={styleHelper({ color: unitPrice?.textColor })}
            >
              {unitPrice?.text ?? ""}
            </span>
          </div>
          <div className="vas-text-16">{IconContent()}</div>
        </div>
      </div>
    </div>
  );
}
